// @ts-nocheck
import { all, call, put, select, takeLatest } from 'redux-saga/effects'

import {
  completeNudgeService,
  deleteSchoolNudgeSetService,
  getAllNudgeSetsService,
  getMyNudgeSetsService,
  getTopNudgeSetService,
  postSchoolNudgeSetService,
} from 'common/services/nudges'
import { changeModal } from 'services/actions'
import mixpanel, { EVENTS } from 'lib/mixpanel'

import {
  COMPLETE_NUDGE,
  LOAD_ALL_NUDGE_SETS,
  LOAD_MY_NUDGE_SETS,
  PUBLISH_NUDGE,
  UNPUBLISH_NUDGE,
} from './actions'

// Helper function to check if all nudges in a specific set are completed
function* checkNudgeSetCompletion(nudgeSetId, isImplementationTeam) {
  // Get the current state
  const state = yield select()

  const sets = isImplementationTeam ? state.nudges.allSets.items : state.nudges.mySets.items

  // If there are no sets, we can't determine completion
  if (!sets || sets.length === 0) {
    return { completed: false }
  }

  // Find the specific set
  const targetSet = sets.find((set) => set.id === nudgeSetId)

  if (!targetSet || !targetSet.nudges || targetSet.nudges.length === 0) {
    return { completed: false }
  }

  // Check if all nudges in this set are completed
  const allCompleted = targetSet.nudges.every((nudge) => nudge.completed_nudge)

  return {
    completed: allCompleted,
    setInfo: targetSet,
  }
}

function* loadAllNudgeSets() {
  yield call(getAllNudgeSetsService.requestSaga, {
    payload: {
      urlParams: {},
    },
  })

  // School Statistics
  yield call(getTopNudgeSetService.requestSaga, {
    payload: {
      urlParams: {},
    },
  })
}

function* loadMyNudgeSets() {
  yield call(getMyNudgeSetsService.requestSaga, {
    payload: {
      urlParams: {},
    },
  })
}

function* completeNudgeSaga({
  payload: { id, nudgeDescription, nudgeSetId, nudgeSetName, isImplementationTeam },
}) {
  yield call(completeNudgeService.requestSaga, {
    payload: {
      data: {
        nudge_id: id,
      },
    },
  })

  mixpanel.track(EVENTS.COMPLETE_NUDGE, {
    nudge_id: id,
    // Strip HTML tags from nudge description
    // Input: "<!-- wp:paragraph --> <p>Visit your <strong><a href="[action_school_profile]">School Profile</a></strong> to get to know your RULER Implementation Team.</p> <!-- /wp:paragraph -->"
    // Output: " Visit your School Profile to get to know your RULER Implementation Team. "
    nudge_description: nudgeDescription.replace(/<\/?[^>]+(>|$)/g, ''),
    nudge_set_id: nudgeSetId,
    nudge_set_name: nudgeSetName,
  })

  yield isImplementationTeam ? loadAllNudgeSets() : loadMyNudgeSets()

  // After loading the updated nudges, check if all nudges in this specific set are completed
  const { completed, setInfo } = yield* checkNudgeSetCompletion(nudgeSetId, isImplementationTeam)

  if (completed) {
    // Track the COMPLETE_ROADMAP_MILESTONE event for this nudge_set (milestone)
    mixpanel.track(EVENTS.COMPLETE_ROADMAP_MILESTONE, {
      nudge_set_id: nudgeSetId,
      nudge_set_name: nudgeSetName,
      nudge_set_type: setInfo?.nudge_set_type?.name || 'unknown',
    })
  }
}

function* publishNudgeSaga({
  payload: { nudgeSetId, schoolId, personId, nudgeSetName, schoolName },
}) {
  yield call(postSchoolNudgeSetService.requestSaga, {
    payload: {
      data: {
        nudge_set_id: nudgeSetId,
        school_id: schoolId,
        person_id: personId,
      },
    },
  })

  mixpanel.track(EVENTS.PUBLISH_NUDGE_SET, {
    nudge_set_id: nudgeSetId,
    nudge_set_name: nudgeSetName,
    school_id: schoolId,
    school_name: schoolName,
  })

  yield loadAllNudgeSets()
  yield put(changeModal({ isOpen: false }))
}

function* unpublishNudgeSaga({ payload: { nudgeSetId, schoolId, nudgeSetName, schoolName } }) {
  yield call(deleteSchoolNudgeSetService.requestSaga, {
    payload: {
      urlParams: {
        nudge_set_id: nudgeSetId,
        school_id: schoolId,
      },
    },
  })

  mixpanel.track(EVENTS.UNPUBLISH_NUDGE_SET, {
    nudge_set_id: nudgeSetId,
    nudge_set_name: nudgeSetName,
    school_id: schoolId,
    school_name: schoolName,
  })

  yield loadAllNudgeSets()
  yield put(changeModal({ isOpen: false }))
}

export default function* saga() {
  yield all([
    takeLatest(PUBLISH_NUDGE, publishNudgeSaga),
    takeLatest(UNPUBLISH_NUDGE, unpublishNudgeSaga),
    takeLatest(COMPLETE_NUDGE, completeNudgeSaga),
    takeLatest(LOAD_ALL_NUDGE_SETS, loadAllNudgeSets),
    takeLatest(LOAD_MY_NUDGE_SETS, loadMyNudgeSets),
  ])
}
